<template>
  <section class="admin-content" id="contact-search">
    <!-- <Navbar /> -->
    <main class="admin-main">
      <!-- <div class="bg-info m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div class="col-md-6 text-center mx-auto text-white p-b-30">
                <div class="m-b-10">
                  <div class="avatar"></div>
                </div>
                <h3 class="h3">Rate your Experience</h3>
              </div>
            </div>
          </div>
        </div> -->

      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          loader="dots"
          :can-cancel="true"
          :is-full-page="fullPage"
        ></loading>
      </div>
      <div class="container card col-md-12">
        <div class="card-header"></div>

        <div class="card-body text-center">
          <p class="h4">Rate Experience at  {{ encounterDetails.provider.agency_name }}</p>
        </div>
      </div>

      <div class="user__details--container" id="printDiv" ref="printNow">
        <div class="user__details--container-main">
          <h1 class="name">
            {{ encounterDetails.enrollee.lastname }}
            {{ encounterDetails.enrollee.firstname }}
          </h1>

          <img
            :src="`https://claimify-api.hayokmedicare.ng/image/${encounterDetails.enrollee.user_image}`"
            alt="Enrollee Image"
            class="enrollee__img"
            onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'"
          />
          <span v-if="encounterDetails.is_confirmed == true">
            <button type="button" class="btn m-1 badge badge-soft-success">
              confirmed
            </button>
          </span>

          <span v-if="encounterDetails.is_confirmed == false">
            <button type="button" class="btn m-1 badge badge-soft-danger">
              rejected
            </button>
          </span>
          
          <div class="primary__detail">
            <i class="fas fa-id-card fa-2x icon"></i>
            <p class="id__number primary__detail--text">
              {{ encounterDetails.enrollee.id_card_number }}
            </p>
          </div>
          <div class="primary__detail">
            <i class="fas fa-phone fa-2x icon"></i>
            <p class="exp__date primary__detail--text">
              {{ encounterDetails.enrollee.phone_number }}
            </p>
          </div>
          <div class="primary__detail">
            <i class="far fa-calendar-alt fa-2x icon"></i>
            <p class="facility primary__detail--text">
              {{ encounterDetails.enrollee.dob }}
            </p>
          </div>
          <div class="primary__detail">
            <i class="fas fa-venus-mars fa-2x icon"></i>
            <p class="facility primary__detail--text">
              {{ encounterDetails.enrollee.gender }}
            </p>
          </div>
          <div class="primary__detail">
            <i class="fas fa-hospital fa-2x icon"></i>
            <p class="mda primary__detail--text">
              {{ encounterDetails.enrollee.sector }}
            </p>
          </div>

          <div class="primary__detail">
            <i class="fas fa-hospital fa-2x icon"></i>
            <p class="mda primary__detail--text">
              {{ encounterDetails.provider.agency_name }}
            </p>
          </div>
        </div>
        <div class="user__-details--container-other">
          <div class="user__details-header-and-renewal__CTA">
            <h1 class="other__details--heading">Treatment Details</h1>
          </div>

          <div v-if="encounterDetails.services">
            <div class="other__details--list">
              <p
                class="other__detail"
                v-if="encounterDetails.diagnosis != null"
              >
                <strong>Treatment For: </strong>
                {{ encounterDetails.diagnosis.name }}
              </p>

              <p class="other__detail">
                <strong>Investigations: </strong>
                {{ encounterDetails.healthrecord.testResult }}
              </p>

              <p class="other__detail">
                <strong>Consultation Note: </strong>
                {{ encounterDetails.healthrecord.notes }}
              </p>
              <p class="other__detail">
                <strong> Date & time of visit: </strong>
                {{ encounterDetails.healthrecord.date_of_visit }}
              </p>
            </div>
          </div>

          <br />

          <button
            v-if="encounterDetails.is_confirmed == null"
            @click="updateEncounterStatus(encounterDetails, true)"
            type="button"
            class="btn btn-outline-success m-1"
            name="button"
          >
            I received this treatment
            <i class="fe fe-check"></i>
          </button>

          <button
            v-if="encounterDetails.is_confirmed == null"
            @click="updateEncounterStatus(encounterDetails, false)"
            type="button"
            class="btn btn-outline-danger m-1"
            name="button"
          >
            I didnot receive this treatment
            <i class="fe fe-x"></i>
          </button>

          <div class="card" v-if="encounterDetails.review == null && encounterDetails.is_confirmed == true">
            <div class="card-header text-center">
              <strong class="h4 card-header"> Review</strong>
            </div>

            <div class="card-body">
              <form @submit.prevent="sendReview">
                <div class="form-group col-md-6 offset-md-3">
                  <star-rating
                    star-size="35"
                    active-color="#198754"
                    :show-rating="false"
                    @rating-selected="setRating"
                  ></star-rating>
                </div>

                <div class="form-group col-md-12">
                  <label for="inputCity"
                    >Tell us about your Experience at
                    {{ encounterDetails.provider.agency_name }}?</label
                  >

                  <p>
                    <button
                      type="button"
                      @click="selectSuggestion(rev)"
                      v-for="rev in reviews"
                      :key="rev"
                      class="btn m-b-15 mx-2 badge badge-soft-dark"
                    >
                      {{ rev }}
                    </button>
                  </p>
                  <textarea
                    required
                    class="form-control"
                    rows="4"
                    v-model="body"
                  ></textarea>
                </div>

                <div class="form-group">
                  <button class="btn btn-success btn-block" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="card" v-if="encounterDetails.review != null">
            <div class="card-header text-center">
              <strong class="h4 card-header"> Review</strong>
            </div>

            <div class="card-body">
              <form @submit.prevent="sendReview">
                <div class="form-group col-md-6 offset-md-3">
                  <star-rating
                    read-only="true"
                    :rating="encounterDetails.rating.score"
                    star-size="35"
                    active-color="#198754"
                    :show-rating="false"
                    @rating-selected="setRating"
                  ></star-rating>
                </div>

                <div class="form-group col-md-12 text-center">
                  <label for="inputCity">
                    {{ encounterDetails.review.body }}</label
                  >
                  <p class="text-muted small mt-1">
                    {{
                      encounterDetails.review.created_at | moment("from", "now")
                    }}
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
  
  <script>
import StarRating from "vue-star-rating";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading,
    StarRating,
  },
  data() {
    return {
      reviews: [
        "The staff were caring and attentive.",
        "I received prompt and efficient service.",
        "The facility was clean and well-organized.",
        "Everyone from the reception to the nurses was friendly and professional",
        "I felt well cared for during my visit.",
        "I was impressed with how quickly I received my test results.",
        "I experienced long wait times during my visit.",
        "The staff seemed overwhelmed and not very attentive to my needs.",
        "I felt my concerns were dismissed by the doctor.",
        "I left without satisfactory answers.",
        "The facility was dirty",
        "I felt neglected during my visit.",
      ],
      encounterDetails: {
        rating:""
      },
      patient: "",
      rating: null,
      isLoading: false,
      encounterId: "",
      providers: "",
      body: "",
      fullPage: true,
    };
  },

  methods: {
    setRating(rating) {
      this.rating = rating;
    },
    selectSuggestion(rev) {
      this.body = rev;
    },
    getUserEncounterDetails() {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/service_summary/${this.$route.params.id}`)
        .then((response) => {
          this.encounterDetails = response.data;
          console.log(this.encounterDetails);
        })
        .catch((error) => {
          console.error(error);
        });
      this.isLoading = false;
    },

    sendReview() {
      if (this.rating == null) {
        this.$toasted.error("Please Leave a rating", {
          position: "top-center",
          duration: 3000,
        });
      } else {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/comments`, {
            provider_id: this.encounterDetails.provider_id,
            user_id: this.encounterDetails.client_id,
            service_summary_id: this.$route.params.id,
            body: this.body,
            score: this.rating,
          })
          .then((response) => {
            this.isLoading = false;

            console.log(response);
            this.$toasted.info("Review Submitted Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.getUserEncounterDetails();
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
          });
      }
    },
    updateEncounterStatus(ecc, status) {
      if (confirm("Are you Sure?")) {
        this.axios
          .post(`/api/v1/auth/updateEncounterStatus`, {
            id: ecc.id,
            is_confirmed: status,
          })
          .then((response) => {
            this.getUserEncounterDetails();
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
  },

  created() {
    this.getUserEncounterDetails();
  },
};
</script>
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700;800;900&display=swap");

html {
  box-sizing: border-box;
  font-size: 62.5%;
  font-family: "Nunito";
}

.spacer {
  margin-top: 10px;
  margin-bottom: 10px;
}

.heading {
  font-size: 1.3rem;
}

.jumbotron {
  background: rgb(72, 172, 179);
  text-align: center;
  color: #fff;
}

.CTA__prompt {
  font-size: 1.4rem;
}

.client__details {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btn {
  margin-bottom: 2rem;
}

input {
  border: none;
  padding: 9px 12px;
  border: 1px solid rgba(60, 66, 87, 0.12);
  width: 50%;
  margin: 1rem 0;
  border-radius: 0.4rem;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.04);
}

select {
  border: none;
  padding: 9px 12px;
  border: 1px solid rgba(60, 66, 87, 0.12);
  width: 70%;
  margin: 1rem 0;
  border-radius: 0.4rem;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.04);
}

.user__details--container {
  height: fit-content;

  display: flex;
}

.user__details-header-and-renewal__CTA {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.user__details--container-main {
  display: flex;
  flex-direction: column;

  padding: 2rem;
  height: fit-content;
  flex: 1;
  align-items: center;
}

.name {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #697386;
}

.primary__detail {
  padding: 1rem 2rem;
  background: #fff;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  border: 1px solid rgba(60, 66, 87, 0.12);
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.04);
  margin-bottom: 1rem;
  border-radius: 0.4rem;
}

.ussd {
  padding: 1rem 2rem;
  background: #fff;
  min-width: 90%;
  border: 1px solid rgba(60, 66, 87, 0.12);
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.04);
  margin: 0 1rem 2rem 1rem;
  border-radius: 0.4rem;
  transition: ease-in-out 0.3s;
  word-wrap: break-word;
}

.fa-2x {
  color: #697386;
}

.primary__detail--text {
  font-weight: 500;
  text-align: right;
}

.enrollee__img {
  width: 65%;
  height: auto;
  margin-bottom: 1rem;
  border-radius: 0.4rem;
}

.user__-details--container-other {
  height: fit-content;
  flex: 2;

  padding: 2rem;
  box-shadow: 0px 15px 30px rgb(0 0 0 / 8%);
}

.other__details--heading {
  font-size: 1.5rem;
  font-weight: 500;
  color: #697386;
}

.other__detail {
  border-bottom: 1px solid rgba(60, 66, 87, 0.12);
  margin-top: 1rem;
}

.image__container {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 64rem) /* 1024/16 = 64 rem */ {
  .user__details--container-main {
    flex: 2;
  }

  .primary__detail {
    width: 100%;
  }
}

@media screen and (max-width: 48.1rem) /* 769/16 = 48.1 rem */ {
  .user__details--container {
    display: block;
    padding: 2rem 1rem;
  }

  .user__details--container-main {
    padding: 0;
  }

  .fa-2x {
    font-size: 1.5rem;
  }

  input {
    width: 92%;
  }

  select {
    width: 100%;
  }
}
</style>
  